export default "__VITE_ASSET__DOEyX0eN__"